import { render, staticRenderFns } from "./ProfileEdition.vue?vue&type=template&id=b5b9716c&"
import script from "./ProfileEdition.vue?vue&type=script&lang=js&"
export * from "./ProfileEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports